export default "__VITE_ASSET__CrGTuM9m__"